import { useContext, useRef, useState } from "react";

import styled from "styled-components/macro";

import API from "Signups/API.js";
import {
  MoreButton,
  MoreButtonText,
} from "Signups/SignupView/SignupSheet/Screens/Options/Options/MoreButton";
import { signupItemStateHooks } from "Signups/SignupView/SignupSheet/Screens/SignupItems/stateHooks.js";
import { SignupsAppState } from "Signups/state.js";

import FnrButton from "UI/FnrButton3";
import FnrIcon from "UI/FnrIcon";
import { FnrPopover } from "UI/FnrPopover2";

export default function UnlinkFromGroup({ signupItemID }) {
  const [showPopover, setShowPopover] = useState(false);
  const buttonRef = useRef();
  const [isLoading, setIsLoading] = useState(false);

  const [
    {
      currentSignupList: { ID: signupListID },
    },
    dispatch,
  ] = useContext(SignupsAppState);

  const { getSignupItem } = signupItemStateHooks.useGetSignupItem();

  const hidePopover = () => {
    if (!isLoading) setShowPopover(false);
  };

  const handleUnlinkClick = () => {
    if (isLoading) return;

    setIsLoading(true);

    API.unlinkSignupItemFromGroup({
      signupID: signupListID,
      signupItemID,
    })
      .post()
      .then(() => {
        getSignupItem(signupItemID);
        dispatch({
          type: "Update Item Group Link",
          linkedToGroup: null,
          signupItemID,
        });
      })
      .catch(() => {
        alert("Something went wrong");
      })
      .finally(() => {
        setIsLoading(false);
        hidePopover();
      });
  };

  return (
    <>
      <MoreButton
        ref={buttonRef}
        onClick={() => setShowPopover(true)}
        forceHover={showPopover}
      >
        <FnrIcon fas fa-unlink />
        <MoreButtonText>Unlink</MoreButtonText>
      </MoreButton>
      <FnrPopover
        show={showPopover}
        onShouldClose={hidePopover}
        buttonRef={buttonRef}
      >
        <AlertWrapper>
          Are you sure you want to unlink this group?
          <Subtext>
            Members will not be removed from the group, but new members who sign
            up for this item will no longer be automatically added to the group.
          </Subtext>
        </AlertWrapper>
        <ButtonsHolder>
          <FnrButton text="Cancel" disabled={isLoading} onClick={hidePopover} />
          <FnrButton
            color="red"
            loading={isLoading}
            onClick={handleUnlinkClick}
            text="Unlink It"
          />
        </ButtonsHolder>
      </FnrPopover>
    </>
  );
}

const AlertWrapper = styled.div`
  padding: 12px;
  width: 280px;
  font-size: 18px;
  line-height: 22px;
  font-weight: 400;
`;
const Subtext = styled.div`
  font-size: 14px;
  line-height: 18px;
  margin-top: 8px;
`;
const ButtonsHolder = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px;
  padding-top: 0;
`;
